/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"
import Img from "gatsby-image"

import Link from "../../atoms/Link"

import marks from "../../../images/marks"
import { getRandomInt } from "../../../utils/math"

const Thumbnail = ({
  image,
  to,
  title,
  subtitle,
  width,
  height,
  children,
  index,
  ...otherProps
}) => (
  <Link to={to} sx={{ display: "block" }} {...otherProps}>
    {image && (
      <div className="image-container" sx={{ position: "relative" }}>
        <div sx={{ overflow: "hidden", mb: "15px" }}>
          <Img
            sx={{
              display: "block",
              transition: "transform 0.6s",
              transformOrigin: "center",
              ".image-container:hover &": {
                transform: "scale(1.05)",
              },
            }}
            fluid={image}
            alt={title}
            style={{
              width,
              minWidth: "100%",
              maxWidth: "100%",
            }}
            imgStyle={{
              width,
              height,
              minWidth: "100%",
              minHeight: "100%",
              maxHeight: "100%",
            }}
          />
        </div>
        <img
          src={marks[`mark${getRandomInt(1, 5, index)}`]}
          alt=""
          aria-hidden
          sx={{
            position: "absolute",
            pointerEvents: "none",
            top: [
              `calc(${getRandomInt(0, 80, index)}% - 15px)`,
              `calc(${getRandomInt(0, 80, index)}% - 25px)`,
            ],
            [getRandomInt(0, 1, index) > 0.5 ? "left" : "right"]: [
              "-3%",
              "-7%",
            ],
            width: "15%",
          }}
        />
      </div>
    )}
    <h3
      sx={{
        variant: "styles.root.h4",
        mb: 2,
        mt: 2,
      }}
    >
      {title}
    </h3>
    {subtitle && <span sx={{ fontSize: [1, 2] }}>{subtitle}</span>}
    {children}
  </Link>
)

Thumbnail.propTypes = {
  image: PropTypes.object,
  to: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
}

Thumbnail.defaultProps = {
  subtitle: null,
}

export default Thumbnail
